import { render } from "./ListeCategorieArticle.vue?vue&type=template&id=c8c5fcc6&ts=true"
import script from "./ListeCategorieArticle.vue?vue&type=script&lang=ts"
export * from "./ListeCategorieArticle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__